var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import BaseHaveLoginRoute from "../../features/auth/routes/have-login";
import { InsuranceType } from "../../constants";
import { PHASE } from "../../routeConfig";
import { completedPage } from "../../lib/Avo";
import { enteredUnlinkedApplication } from "../../features/unlinked-application/unlinkedApplicationSlice";
import useAppDispatch from "../../hooks/useAppDispatch";
import useAppSelector from "../../hooks/useAppSelector";
import useCreateAccountRoute from "../../hooks/useCreateAccountRoute";
export default function HaveHomeLoginRoute() {
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics; }).commonAnalyticsProperties;
    var selectedIssuer = useAppSelector(function (state) { return state.applicant.currentIssuer.home; });
    var dispatch = useAppDispatch();
    var createAccountRoute = useCreateAccountRoute(InsuranceType.Home);
    var options = [
        {
            label: "Yes",
            nextPhase: PHASE.HOME_REMEMBER_LOGIN,
            onSelect: function () {
                completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: "Yes", optionSelected: "Yes" }));
            },
        },
        {
            label: "No",
            nextPhase: createAccountRoute,
            onSelect: function () {
                dispatch(enteredUnlinkedApplication("no-login"));
                completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: "No", optionSelected: "No" }));
            },
        },
    ];
    if (!(selectedIssuer === null || selectedIssuer === void 0 ? void 0 : selectedIssuer.id)) {
        return null;
    }
    return React.createElement(BaseHaveLoginRoute, { issuer: selectedIssuer, options: options });
}
